/* eslint @typescript-eslint/no-explicit-any: 0 */
import { getOverrides as baseGetOverrides } from '../baseui/helpers/overrides';
import { useMemo } from 'react';
var getOverrides = function (override, defaultComponent) {
    if (override === void 0) { override = {}; }
    return baseGetOverrides(override, defaultComponent);
};
/**
 * Wrapper on top of getOverrides of baseui.
 */
var useOverrides = function (override, defaultComponent) {
    return useMemo(function () { return getOverrides(override, defaultComponent); }, [override, defaultComponent]);
};
export { getOverrides, useOverrides };
